import React from 'react';
import { Box, Typography, Button, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Shared public job detail body (used on standalone `/public/jobs/:id` and inside split portal).
 */
export function PublicJobDetailBody({ job, compact }) {
  if (!job) return null;
  const loc =
    job.location || [job.city, job.state].filter(Boolean).join(', ') || '—';

  return (
    <>
      <Typography variant="overline" color="text.secondary">
        {job.job_code}
      </Typography>
      <Typography variant={compact ? 'h5' : 'h4'} sx={{ fontWeight: 700, mb: 1 }}>
        {job.title}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        {job.client?.name || job.client?.company_name || '—'} · {loc} · {job.remote_option || '—'}
        {job.employment_type ? ` · ${job.employment_type}` : ''}
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
        Role overview
      </Typography>
      <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
        {job.description_external || '—'}
      </Typography>
      {(job.skills_required || job.skills_preferred) && (
        <>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mt: 2, mb: 0.5 }}>
            Skills
          </Typography>
          <Typography variant="body2">{job.skills_required || '—'}</Typography>
          {job.skills_preferred && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Preferred: {job.skills_preferred}
            </Typography>
          )}
        </>
      )}
      <Box sx={{ mt: 3, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        <Button component={RouterLink} to="/signup" variant="contained">
          Sign up to apply
        </Button>
        <Button component={RouterLink} to="/login">
          Log in
        </Button>
      </Box>
    </>
  );
}
